// LOAD ALL THE READ ONLY DATA
import { makeSetReducer } from "./utils";

export const estadosVentaFullfilledReducer = makeSetReducer(['estados_venta/fullfilled']);
